export default "__VITE_ASSET__DtcWeFVg__"